import { motion } from "framer-motion";

const team = [
  {
    name: "Alex Moore",
    role: "Head Videographer",
    img: "https://static.wixstatic.com/media/1fe187_c96ade0f4d2f43c6bc7bd9a10bf59fee~mv2.jpg/v1/crop/x_1260,y_0,w_3666,h_4126/fill/w_574,h_646,al_c,q_85/alex.jpg",
  },
  {
    name: "Ellis Goward",
    role: "Videographer & Photographer",
    img: "https://static.wixstatic.com/media/1fe187_451802347d194e08b9aff9bef88309b1~mv2.jpg/v1/crop/x_1196,y_0,w_4037,h_4541/fill/w_574,h_646,al_c,q_85/ellis.jpg",
  },
  {
    name: "Shannon Barrett",
    role: "Head Editor & Videographer",
    img: "https://static.wixstatic.com/media/1fe187_ea4823a578234aaa96c2d6a1fe27d371~mv2.jpg/v1/crop/x_1426,y_0,w_4151,h_4672/fill/w_574,h_646,al_c,q_85/shannon.jpg",
  },
  {
    name: "Amie Evans",
    role: "Videographer",
    img: "https://static.wixstatic.com/media/1fe187_b445f84e474d48caaecdc648dc20d990~mv2.jpg/v1/crop/x_1246,y_0,w_3803,h_4277/fill/w_574,h_646,al_c,q_85/amie.jpg",
  },
  {
    name: "Andy Thomas",
    role: "Photographer",
    img: "https://static.wixstatic.com/media/1fe187_b4bcb01ce0fd4d69bd6112e2c785b2b1~mv2.jpg/v1/crop/x_1259,y_0,w_3663,h_4123/fill/w_574,h_646,al_c,q_85/andy.jpg",
  },
  {
    name: "Lily Wright",
    role: "Videographer",
    img: "https://static.wixstatic.com/media/1fe187_d630ef3202814fab9a919b8a8c87e28d~mv2.jpg/v1/crop/x_1365,y_0,w_4259,h_4791/fill/w_574,h_646,al_c,q_85/lily.jpg",
  },
];

export const Team = () => (
  <section id="team" className="py-24 sm:py-32" data-testid="team-section">
    <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-16"
      >
        <p className="text-sm uppercase tracking-[0.3em] font-semibold text-[#E80042] mb-4">05 — The Humans</p>
        <h2 className="font-grotesk font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none">
          The crew behind <span className="text-[#E80042]">the camera.</span>
        </h2>
      </motion.div>

      <div className="grid sm:grid-cols-3 gap-6">
        {team.map((m, i) => (
          <motion.div
            key={m.name}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.12 }}
            className={`group ${i % 3 === 1 ? "sm:mt-12" : ""}`}
            data-testid={`team-card-${i + 1}`}
          >
            <div className="relative overflow-hidden rounded-lg">
              <img loading="lazy"
                src={m.img}
                alt={m.name}
                className="w-full h-[420px] object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-[filter,transform] duration-500"
              />
              <div className="absolute inset-x-0 bottom-0 h-1.5 bg-[#E80042] origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" />
            </div>
            <h3 className="font-display uppercase text-3xl mt-6 tracking-tight">{m.name}</h3>
            <p className="text-[#555555] uppercase text-sm tracking-[0.2em] mt-2">{m.role}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
